import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';


const StyledIconButton = glamorous.button({
  padding: '1em',
  width: '100px',
  height: '100px',
  cursor: 'pointer',
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  backgroundRepeat: 'no-repeat',
  border: 'none',
  overflow: 'hidden',
  outline: 'none',
  WebkitBoxShadow: 'none',
  MozBoxShadow: 'none',
  borderRadius: '50px',
  '&:hover': {
    border: '1px solid #B68962',
    backgroundColor: '#B68962',
    transform: 'scale(1.1)',
    transition: 'all .5s ease-in-out',
  },
  '&:hover svg>g': {
    fill: '#B68962',
    stroke: '#FAFAFA',
  },
});


export default class IconButton extends React.PureComponent {
  render() {
    return (
      <StyledIconButton >
        {this.props.icon}
      </StyledIconButton>
    );
  }
}

IconButton.propTypes = {
  /** Should be an svg component */
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

IconButton.defaultProps = {
  icon: null,
};



// WEBPACK FOOTER //
// ./src/app/components/IconButton.jsx